export default __webpack_public_path__ + "static/media/Boots of the Atlantean.9f113daa.jpg";